// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.themesel {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.themesel .setting-th {
  display: flex;
}
.themesel .setting-th .setting-first,
.themesel .setting-th .setting-second {
  width: 7%;
}
.themesel .setting-th .setting-first .themesel-title,
.themesel .setting-th .setting-second .themesel-title {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
}
.themesel .setting-th .setting-first .dashboard-staging-dropdown,
.themesel .setting-th .setting-second .dashboard-staging-dropdown {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #555;
}
.themesel .setting-th .setting-first-data,
.themesel .setting-th .setting-second-data {
  width: 25%;
}
.themesel .setting-th .theme-colors {
  display: flex;
  gap: 5px;
  width: 25%;
}
.themesel .setting-th .theme-colors .themecol {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #d1d5db;
  transition: transform 0.15s ease-in-out;
}
.themesel .setting-th .theme-colors .themecol:hover {
  transform: scale(1.1);
}
.themesel .setting-th .theme-colors .themecol.selected {
  border: 2px solid #6c757d;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .themesel .setting-th .setting-first,
  .themesel .setting-th .setting-second {
    width: 20%;
  }
  .themesel .setting-th .setting-first-data,
  .themesel .setting-th .setting-second-data {
    width: 55%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Settings.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;AACJ;AACI;;EAEE,SAAA;AACN;AACM;;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AAER;AACM;;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAER;AAEI;;EAEE,UAAA;AAAN;AAGI;EACE,aAAA;EACA,QAAA;EACA,UAAA;AADN;AAGM;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uCAAA;AADR;AAGQ;EACE,qBAAA;AADV;AAKM;EACE,yBAAA;EACA,sCAAA;AAHR;;AASA;EAIM;;IAEE,UAAA;EATN;EAYI;;IAEE,UAAA;EAVN;AACF","sourcesContent":[".themesel {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .setting-th {\n    display: flex;\n\n    .setting-first,\n    .setting-second {\n      width: 7%;\n\n      .themesel-title {\n        font-size: 0.9rem;\n        color: #333;\n        font-weight: 500;\n      }\n\n      .dashboard-staging-dropdown {\n        width: 100%;\n        padding: 8px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        font-size: 0.9rem;\n        color: #555;\n      }\n    }\n\n    .setting-first-data,\n    .setting-second-data {\n      width: 25%;\n    }\n\n    .theme-colors {\n      display: flex;\n      gap: 5px;\n      width: 25%;\n\n      .themecol {\n        width: 1.4rem;\n        height: 1.4rem;\n        border-radius: 50%;\n        cursor: pointer;\n        border: 1px solid #d1d5db;\n        transition: transform 0.15s ease-in-out;\n\n        &:hover {\n          transform: scale(1.1);\n        }\n      }\n\n      .themecol.selected {\n        border: 2px solid #6c757d;\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .themesel {\n    .setting-th {\n\n      .setting-first,\n      .setting-second {\n        width: 20% ;\n      }\n\n      .setting-first-data,\n      .setting-second-data {\n        width: 55% ;\n      }\n    }\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
